<template>
  <div class="box">
    <div class="boxTop">
      <div class="bx-content">
        <div class="head-box">
          <headerPage />
        </div>

        <div class="banner">
          <div class="title-h4">市委社会工作领导小组办公室</div>
          <div class="title-img">
            <img src="@/assets/images/titleh1.png" alt="" />
          </div>
          <div class="title-time">征集时间：本公告发布之日至2026年4月30日</div>
          <div class="title-btn">
            <button @click="to('/detail')">
              查看公告 <i class="iconfont icon-jiantou_xiangyou"></i>
            </button>
          </div>
        </div>

        <div class="shuoming">
          <div class="shuoming-content">
            <div class="shuoming-title">填表说明</div>
            <div class="shuoming-tex">
              一、“申报单位”指申报项目的各类社会组织，“实施地”指项目实施地相关街道（乡镇）或区级相关部门等。
            </div>
            <div class="shuoming-tex">
              二、项目方向请按公告中的“项目方向”填写。
            </div>
            <div class="shuoming-tex">
              三、表内第一、二、三、四、五项由申报单位按要求填写；
              第六项需由申报单位负责人签名并加盖单位公章；第七项由项目实施地单位填写并加盖单位公章。
            </div>
            <div class="shuoming-tex">
              四、申报内容填写不实的，将取消项目入库资格，申报单位三年内不得再次申报项目。
            </div>
            <div class="shuoming-tex">
              五、填报过程中的相关问题可按公告中的联系方式咨询。
            </div>
          </div>
        </div>

        <div class="boxCenter">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
            class="ruleForm publish-form"
            v-loading="loading"
          >
            <div class="boxMain">
              <div class="item-feedback" v-if="ruleForm.approve_status == 3">
                驳回原因：<span>{{ ruleForm.refund_reason }}</span>
              </div>

              <div class="form-tit">
                <i></i>
                <b>一、基本情况</b>
              </div>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    ref="project_name"
                    label="项目名称"
                    prop="project_name"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.project_name"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    label="申报单位"
                    required
                    class="input-container"
                  >
                    <el-input
                      v-model="user.organ_name"
                      placeholder="请输入"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="14">
                  <el-form-item
                    ref="project_class"
                    label="项目方向"
                    prop="project_class"
                    class="input-container"
                  >
                    <el-select
                      v-model="ruleForm.project_class"
                      placeholder="请选择"
                      @change="child()"
                    >
                      <el-option
                        v-for="item in directionOne"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    ref="project_direction"
                    label-width="0"
                    prop="project_direction"
                    class="input-container"
                  >
                    <el-select
                      v-model="ruleForm.project_direction"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in directionTwo"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="10">
                  <el-form-item
                    ref="province_id"
                    label="实施地"
                    prop="province_id"
                    class="input-container"
                  >
                    <el-select
                      v-model="ruleForm.province_id"
                      placeholder="请选择"
                      @change="cityList()"
                    >
                      <el-option
                        v-for="item in provinceclass"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item
                    ref="city_id"
                    label-width="0"
                    prop="city_id"
                    class="input-container"
                  >
                    <el-select v-model="ruleForm.city_id" placeholder="请选择">
                      <el-option
                        v-for="item in cityclass"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item
                    ref="land_area"
                    label-width="0"
                    prop="land_area"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.land_area"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    ref="organ_class"
                    label="申报单位属性"
                    prop="organ_class"
                    class="input-container"
                  >
                    <el-select
                      v-model="ruleForm.organ_class"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in orgclass"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="mail_address"
                    label="通讯地址"
                    prop="mail_address"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.mail_address"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邮政编码" class="input-container">
                    <el-input
                      v-model="ruleForm.post_code"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="email"
                    label="电子信箱"
                    prop="email"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.email"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="传真电话" class="input-container">
                    <el-input
                      v-model="ruleForm.fax_phone"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="legal_person"
                    label="法定代表人"
                    prop="legal_person"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.legal_person"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="corporate_code"
                    label="法人代码"
                    prop="corporate_code"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.corporate_code"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="charge_name"
                    label="项目负责人姓名"
                    prop="charge_name"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.charge_name"
                      placeholder="请输入项目负责人姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="charge_job"
                    label="项目负责人职务"
                    prop="charge_job"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.charge_job"
                      placeholder="请输入项目负责人职务"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="项目负责人电话" class="input-container">
                    <el-input
                      v-model="ruleForm.charge_tel"
                      placeholder="请输入项目负责人办公电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="charge_phone"
                    label="项目负责人手机"
                    prop="charge_phone"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.charge_phone"
                      placeholder="请输入手机号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="contact_name"
                    label="项目联系人姓名"
                    prop="contact_name"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.contact_name"
                      placeholder="请输入项目联系人姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="contact_job"
                    label="项目联系人职务"
                    prop="contact_job"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.contact_job"
                      placeholder="请输入项目联系人职务"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="联系人电话" class="input-container">
                    <el-input
                      v-model="ruleForm.contact_tel"
                      placeholder="请输入项目联系人办公电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="contact_phone"
                    label="项目联系人手机"
                    prop="contact_phone"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.contact_phone"
                      placeholder="请输入手机号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    ref="implement_organ_name"
                    label="实施地单位"
                    prop="implement_organ_name"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_organ_name"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="implement_mail_address"
                    label="实施地通讯地址"
                    prop="implement_mail_address"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_mail_address"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="实施地邮政编码" class="input-container">
                    <el-input
                      v-model="ruleForm.implement_post_code"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref=""
                    label="实施地电子信箱"
                    prop=""
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_email"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="实施地传真电话" class="input-container">
                    <el-input
                      v-model="ruleForm.implement_fax_phone"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="implement_charge_name"
                    label="实施地负责人姓名"
                    prop="implement_charge_name"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_charge_name"
                      placeholder="请输入实施地负责人姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="implement_charge_job"
                    label="实施地负责人职务"
                    prop="implement_charge_job"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_charge_job"
                      placeholder="请输入实施地负责人职务"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    label="实施地负责人电话"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_charge_tel"
                      placeholder="请输入实施地负责人办公电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="implement_charge_phone"
                    label="实施地负责人手机"
                    prop="implement_charge_phone"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_charge_phone"
                      placeholder="请输入手机号码，如无实施地，可填“无”"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    ref="implement_contact_name"
                    label="实施地联系人姓名"
                    prop="implement_contact_name"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_contact_name"
                      placeholder="请输入实施地联系人姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="implement_contact_job"
                    label="实施地联系人职务"
                    prop="implement_contact_job"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_contact_job"
                      placeholder="请输入实施地联系人职务"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    label="实施地联系人电话"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_contact_tel"
                      placeholder="请输入实施地联系人办公电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    ref="implement_contact_phone"
                    label="实施地联系人手机"
                    prop="implement_contact_phone"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.implement_contact_phone"
                      placeholder="请输入手机号码，如无实施地，可填“无”"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>二、申报单位简介（200 字以内）</b>
              </div>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    label="申报单位简介"
                    ref="organ_introduce"
                    prop="organ_introduce"
                    class="input-container"
                  >
                    <el-input
                      type="textarea"
                      v-model="ruleForm.organ_introduce"
                      rows="5"
                      resize="none"
                      maxlength="200"
                      show-word-limit
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="form-tit">
                <i></i>
                <b>三、项目简介（200 字以内）</b>
              </div>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    label="项目简介"
                    ref="project_introduce"
                    prop="project_introduce"
                    class="input-container"
                  >
                    <el-input
                      type="textarea"
                      v-model="ruleForm.project_introduce"
                      rows="5"
                      resize="none"
                      maxlength="200"
                      show-word-limit
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="form-tit">
                <i></i>
                <b>四、项目论证</b>
              </div>
              <el-row :gutter="24">
                <el-col :span="24">
                  <div
                    class=""
                    v-for="(item, index) in ruleForm.project_assessment"
                    :key="item.id"
                  >
                    <div class="titles">
                      <b v-if="ruleForm.project_assessment.length - 1 != index"
                        >*</b
                      >{{ item.title }}
                    </div>
                    <el-form-item
                      label-width="0"
                      :ref="'project_assessment.' + index + '.value'"
                      :prop="'project_assessment.' + index + '.value'"
                      :rules="{
                        required: true,
                        message: '请输入',
                        trigger: 'blur',
                      }"
                      class="input-container"
                    >
                      <el-input
                        :type="item.type"
                        v-model="item.value"
                        :placeholder="item.placeholder"
                        rows="8"
                        resize="none"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b
                  >五、经费预算
                  <span @click="dialogVisible = true"
                    >点击查看2026年北京市社会组织服务项目预算测算参考标准</span
                  ></b
                >
              </div>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item
                    label="资金预算"
                    label-width="300px"
                    ref="funding_budget"
                    prop="funding_budget"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.funding_budget"
                      @blur="budgetMoney"
                      placeholder="请输入"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="16">
                  <el-form-item
                    label="其中：可自筹资金数额（比例）"
                    label-width="300px"
                    ref="self_account"
                    prop="self_account"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.self_account"
                      @blur="budgetMoney"
                      placeholder="请输入"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label-width="0"
                    ref="self_percent"
                    prop="self_percent"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.self_percent"
                      @blur="budgetMoneyBFB"
                      placeholder="请输入"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="16">
                  <el-form-item
                    label="其中：需支持的资金数额（比例）"
                    label-width="300px"
                    ref="support_account"
                    prop="support_account"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.support_account"
                      @blur="budgetMoney"
                      placeholder="请输入"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label-width="0"
                    ref="support_percent"
                    prop="support_percent"
                    class="input-container"
                  >
                    <el-input
                      v-model="ruleForm.support_percent"
                      @blur="budgetMoneyBFB"
                      placeholder="请输入"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="num-box">
                <b><span>*</span>项目经费支出明细</b>
                <span>合计金额：{{ ruleForm.total_account }}元</span>
              </div>
              <el-form-item
                ref="account_record"
                label-width="0"
                prop="account_record"
                class="input-container"
              >
                <div class="tabel-box">
                  <el-table
                    :data="ruleForm.account_record"
                    :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }"
                    border
                    style="width: 100%"
                  >
                    <el-table-column type="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column prop="type" label="费用类别" width="150">
                    </el-table-column>
                    <el-table-column
                      prop="price"
                      label="单价（元）"
                      width="150"
                    >
                    </el-table-column>
                    <el-table-column prop="unit" label="标准" width="150">
                    </el-table-column>
                    <el-table-column prop="number" label="数量" width="80">
                    </el-table-column>
                    <el-table-column
                      prop="total_price"
                      label="资金金额（元）"
                      width="150"
                    >
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>

                    <el-table-column label="操作" width="150">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="handleEdit(scope.$index, scope.row)"
                          >编辑</el-button
                        >
                        <el-button
                          size="mini"
                          type="danger"
                          @click="handleDelete(scope.$index, 'account_record')"
                          >删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="addbtn">
                    <span @click="handleEdit('', {})">+添加信息</span>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>其他佐证</b>
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="上传资料" class="input-container">
                    <upload-file
                      class="flex justify-start"
                      name="other_file"
                      auth
                      @uploadFile="uploadFile"
                    >
                      <div class="image text-left" slot="upload">
                        <div
                          slot="error"
                          class="image-slot text-gray flex flex-direction align-center justify-center"
                        >
                          <i class="iconfont icon-yunshangchuan"></i>
                          <div>上传文件</div>
                          <p>支持上传pdf/word/zip格式文件20MB以内</p>
                        </div>
                      </div>
                    </upload-file>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.other_file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'other_file')">删除</span>
                </div>
              </div>
            </div>
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>WORD/WPS可编辑版实施方案 </b>
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="上传资料" class="input-container">
                    <!-- 只能上传word文档 application/word -->
                    <upload-file
                      class="flex justify-start"
                      name="word_file"
                      auth
                      @uploadFile="uploadFile"
                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    >
                      <div class="image text-left" slot="upload">
                        <div
                          slot="error"
                          class="image-slot text-gray flex flex-direction align-center justify-center"
                        >
                          <i class="iconfont icon-yunshangchuan"></i>
                          <div>上传文件</div>
                          <p>支持上传WORD格式文件20MB以内</p>
                        </div>
                      </div>
                    </upload-file>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.word_file"
                  :key="index"
                >
                  <!-- target="_blank" -->
                  <a :href="item.href">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'word_file')">删除</span>
                </div>
              </div>
            </div>
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>PDF盖章版实施方案</b>
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="上传资料" class="input-container">
                    <upload-file
                      class="flex justify-start"
                      name="pdf_file"
                      auth
                      accept="application/pdf"
                      @uploadFile="uploadFile"
                    >
                      <div class="image text-left" slot="upload">
                        <div
                          slot="error"
                          class="image-slot text-gray flex flex-direction align-center justify-center"
                        >
                          <i class="iconfont icon-yunshangchuan"></i>
                          <div>上传文件</div>
                          <p>支持上传PDF格式文件20MB以内</p>
                        </div>
                      </div>
                    </upload-file>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.pdf_file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <span @click="handleDelete(index, 'pdf_file')">删除</span>
                </div>
              </div>
            </div>

            <!--            <div class="boxMain" v-if="idList.includes(ruleForm.id)">-->
            <!--              <div class="form-tit">-->
            <!--                <i></i>-->
            <!--                <b>WORD/WPS可编辑版实施方案（补充资料） </b>-->
            <!--              </div>-->

            <!--              <el-row :gutter="24">-->
            <!--                <el-col :span="6">-->
            <!--                  <el-form-item label="上传资料" class="input-container">-->
            <!--                    &lt;!&ndash; 只能上传word文档 application/word &ndash;&gt;-->
            <!--                    <upload-file-->
            <!--                      class="flex justify-start"-->
            <!--                      name="reload_word_file"-->
            <!--                      auth-->
            <!--                      @uploadFile="uploadFile"-->
            <!--                      accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"-->
            <!--                    >-->
            <!--                      <div class="image text-left" slot="upload">-->
            <!--                        <div-->
            <!--                          slot="error"-->
            <!--                          class="image-slot text-gray flex flex-direction align-center justify-center"-->
            <!--                        >-->
            <!--                          <i class="iconfont icon-yunshangchuan"></i>-->
            <!--                          <div>上传文件</div>-->
            <!--                          <p>支持上传WORD格式文件20MB以内</p>-->
            <!--                        </div>-->
            <!--                      </div>-->
            <!--                    </upload-file>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
            <!--              </el-row>-->

            <!--              <div class="ziplist">-->
            <!--                <div-->
            <!--                  class="zip-item"-->
            <!--                  v-for="(item, index) in ruleForm.reload_word_file"-->
            <!--                  :key="index"-->
            <!--                >-->
            <!--                  &lt;!&ndash; target="_blank" &ndash;&gt;-->
            <!--                  <a :href="item.href">{{ item.name }}</a>-->
            <!--                  <span @click="handleDelete(index, 'reload_word_file')"-->
            <!--                    >删除</span-->
            <!--                  >-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="boxMain" v-if="idList.includes(ruleForm.id)">-->
            <!--              <div class="form-tit">-->
            <!--                <i></i>-->
            <!--                <b>PDF盖章版实施方案（补充资料）</b>-->
            <!--              </div>-->

            <!--              <el-row :gutter="24">-->
            <!--                <el-col :span="6">-->
            <!--                  <el-form-item label="上传资料" class="input-container">-->
            <!--                    <upload-file-->
            <!--                      class="flex justify-start"-->
            <!--                      name="reload_pdf_file"-->
            <!--                      auth-->
            <!--                      accept="application/pdf"-->
            <!--                      @uploadFile="uploadFile"-->
            <!--                    >-->
            <!--                      <div class="image text-left" slot="upload">-->
            <!--                        <div-->
            <!--                          slot="error"-->
            <!--                          class="image-slot text-gray flex flex-direction align-center justify-center"-->
            <!--                        >-->
            <!--                          <i class="iconfont icon-yunshangchuan"></i>-->
            <!--                          <div>上传文件</div>-->
            <!--                          <p>支持上传PDF格式文件20MB以内</p>-->
            <!--                        </div>-->
            <!--                      </div>-->
            <!--                    </upload-file>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
            <!--              </el-row>-->

            <!--              <div class="ziplist">-->
            <!--                <div-->
            <!--                  class="zip-item"-->
            <!--                  v-for="(item, index) in ruleForm.reload_pdf_file"-->
            <!--                  :key="index"-->
            <!--                >-->
            <!--                  <a :href="item.href" target="_blank">{{ item.name }}</a>-->
            <!--                  <span @click="handleDelete(index, 'reload_pdf_file')"-->
            <!--                    >删除</span-->
            <!--                  >-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="boxMain" v-if="1 === 2">
              <div class="form-tit">
                <i></i>
                <b> 初审结果 </b>
              </div>

              <el-form-item
                ref="checkList"
                label-width="0"
                prop="checkList"
                class="input-container"
              >
                <div class="tabel-box">
                  <el-table
                    :data="ruleForm.checkList"
                    :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }"
                    border
                    style="width: 100%"
                  >
                    <el-table-column type="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column prop="role_type" label="角色">
                      <template slot-scope="scope">
                        <span v-if="scope.row.role_type == 1">财务专家</span>
                        <span v-else-if="scope.row.role_type == 2"
                          >业务专家</span
                        >
                        <span v-else>管理专家</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="score" label="评分">
                    </el-table-column>
                    <el-table-column prop="admin_name" label="评分专家">
                    </el-table-column>
                    <el-table-column prop="reason" label="专家意见">
                    </el-table-column>
                    <el-table-column prop="create_time" label="评分时间">
                      <template slot-scope="scope">
                        {{ scope.row.create_time }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="approve_time" label="操作">
                      <template slot-scope="scope">
                        <el-button type="primary" @click="showItem(scope.row)">
                          查看
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </div>
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>申报单位承诺</b>
              </div>
              <el-row :gutter="24">
                <el-col :span="24">
                  <div style="width: 100%; margin-top: 20px">
                    <el-checkbox
                      v-model="ruleForm.is_agree"
                      :true-label="1"
                      :false-label="0"
                      ><span style="font-size: 16px"
                        >我们确认项目申报内容的真实性，并愿意承担相应的责任。</span
                      ></el-checkbox
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form>
          <div class="btnbox">
            <span class="bor" @click="login('ruleForm', 1)" v-if="id">
              提交实施方案
            </span>
            <a
              class="bor"
              :href="`${baseURL}/api/Project/preview?project_id=${id}`"
              target="_blank"
              v-if="id"
            >
              预览
            </a>
            <a
              class="bor"
              href="javascript:;"
              @click="exportProjectPdf"
              v-if="id"
            >
              下载
            </a>
            <!--            <span class="bg" @click="login('ruleForm',2)" v-if=" ruleForm.approve_status != 2">添加项目</span>-->
            <div class="tips">请保存后预览、下载</div>
          </div>
        </div>
      </div>
    </div>
    <AddCommon
      :dialog="addBool"
      :row="row"
      :idx="idx"
      @watchState="watchState"
    />
    <attachment :dialogVisible="dialogVisible" @watchState="attachmentFun" />
    <footerPage />

    <apply-level1-dialog
      :dialog="applyLevel1Dialog"
      :id="scoreInfo.project_id"
      :rid="scoreInfo.id"
      :isUser="true"
      @watchState="dialogWatchState"
    ></apply-level1-dialog>
    <apply-level2-dialog
      :dialog="applyLevel2Dialog"
      :id="scoreInfo.project_id"
      :rid="scoreInfo.id"
      :isUser="true"
      @watchState="dialogWatchState"
    ></apply-level2-dialog>
  </div>
</template>

<script>
import headerPage from "./common/headerPage";
import footerPage from "./common/footerPage";
import AddCommon from "./common/addCommonDialog";
import attachment from "./common/lookattachmentDialog";
import UploadFile from "@/components/UploadFile";
import ApplyLevel1Dialog from "@/views/adminhome/common/ApplyLevel1Dialog";
import ApplyLevel2Dialog from "@/views/adminhome/common/ApplyLevel2Dialog";
import {
  cityList,
  getOrganClassList,
  getProjectClassLevelList,
  getProjectClassList,
  saveProjectApplication,
  getProjectApplicationDetail,
  exportProjectPdf,
  isEnd,
  saveProjectFileInfo,
} from "@/api";
import { scrollIntoView, addAd } from "@/tools";
import { baseURL } from "@/config";
import Vue from "vue";
import rules from "@/utils/rules";
import { zhDate } from "@/tools";
export default {
  name: "formsub",
  data() {
    var checkAge = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error("请添加项目经费支出明细"));
      } else {
        callback();
      }
    };

    var checkPhone = (rule, value, callback) => {
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (!value) {
        return callback(new Error("请输入"));
      } else if (value == "无") {
        callback();
      } else if (!reg.test(value)) {
        return callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };

    return {
      scoreInfo: [],
      applyLevel1Dialog: false,
      applyLevel2Dialog: false,
      baseURL: baseURL,
      dialogVisible: false,
      loading: false,
      addBool: false,
      end: 1,
      timer: null,
      row: {},
      idx: "",
      id: "",
      directionOne: [], // 项目方向1options
      directionTwo: [], // 项目方向2options
      orgclass: [], // 申报单位属性options
      provinceclass: [], // 项目落地区域省options
      cityclass: [], // 项目落地区域省市options
      ruleForm: {
        project_name: "", // 项目名称
        project_class: "", // 项目方向1
        project_direction: "", // 项目方向2
        organ_class: "", // 申报单位属性
        province_id: "", // 实施地省
        city_id: "", // 实施地市
        land_area: "", // 实施地区
        mail_address: "", // 通讯地址
        post_code: "", // 邮政编码
        email: "", // 电子信箱
        fax_phone: "", // 传真电话
        legal_person: "", // 法定代表人
        corporate_code: "", // 法人代码
        charge_name: "", // 负责人姓名
        charge_job: "", // 负责人职务
        charge_tel: "", // 负责人电话
        charge_phone: "", // 负责人手机
        contact_name: "", // 联系人姓名
        contact_job: "", // 联系人职务
        contact_tel: "", // 联系人电话
        contact_phone: "", // 联系人手机
        implement_organ_name: "", // 实施地单位
        implement_mail_address: "", // 实施地 通讯地址
        implement_post_code: "", // 实施地 邮政编码
        implement_email: "", // 实施地 电子信箱
        implement_fax_phone: "", // 实施地 传真电话
        implement_charge_name: "", // 实施地 负责人姓名
        implement_charge_job: "", // 实施地 负责人职务
        implement_charge_tel: "", // 实施地 负责人电话
        implement_charge_phone: "", // 实施地 负责人手机
        implement_contact_name: "", // 实施地 联系人姓名
        implement_contact_job: "", // 实施地 联系人职务
        implement_contact_tel: "", // 实施地 联系人电话
        implement_contact_phone: "", // 实施地 联系人手机
        organ_introduce: "", // 申报单位简介
        project_introduce: "", // 项目简介
        project_assessment: [
          // 项目论证
          {
            type: "textarea",
            placeholder: "请输入",
            title: "（一）项目实施的必要性、可行性",
            value: "",
            id: 1,
          },
          {
            type: "textarea",
            placeholder:
              "1、项目实施的已有基础〔说明：包括但不限于项目实施已有的相关经验或有助于项目实施的资源支持等。）" +
              "2、具体方法和途径〔说明：包括项目实施的具体方式、途径。明确项目的具体组成内容，每类、每次活动的具体内容、形式、对象、次数、人数等。〕" +
              "3、进度安排〔说明：建议时间单元为月，不建议简单表述为“年内”、“上半年”、“下半年”、“第*季度”等。〕" +
              "4、预期效果〔说明：具体明确项目实施所要达到的目标或预期的效果。〕" +
              "5、项目团队及分工〔说明：包括项目实施的组织管理机构组成，各有关协作单位等。如以街道社区社会组织联合会名义申报社区社会组织承接的项目，要细化项目的组织实施体系。如有涉及到委托管理（如财务委托管理）的，要在组织架构中予以说明。要把可能引起转包嫌疑的所有事项交代清楚，避免在检查、审计和评估中产生误解。〕",
            title:
              "（二）项目实施的已有基础、具体方法和途径及进度安排、预期效果及完成时间",
            value: "",
            id: 2,
          },
          {
            type: "textarea",
            placeholder: "请输入",
            title:
              "（三）项目实施涵盖的范围、实施的规模、服务的人群、创新之处等",
            value: "",
            id: 3,
          },
          {
            type: "textarea",
            placeholder: "请输入",
            title: "（四）其他",
            value: "",
            id: 4,
          },
        ],
        funding_budget: "", // 资金预算
        self_account: "", // 可自筹资金数额元
        self_percent: "", // 可自筹资金数额%
        support_account: "", // 需支持的资金数额元
        support_percent: "", // 需支持的资金数额%
        account_record: [
          // {
          //   type:'类别',
          //   price:1.00,
          //   number:2,
          //   remark:'',
          //   total_price:300.00,
          // },
        ],
        total_account: "", //项目经费支出明细合计金额
        other_file: [],
        is_agree: 0,
        checkedother: false,

        pdf_file: [],

        word_file: [],

        reload_pdf_file: [],

        reload_word_file: [],
      },
      idList: [
        // 366, 1069, 93, 197, 506, 845
        452, 199, 177, 214, 337, 244, 119, 432, 269, 256, 33, 317, 273, 185,
        441, 18, 311, 217, 215, 88, 193, 135, 195, 25, 260, 449, 445, 378, 252,
        20, 309, 248, 196, 254, 40, 75, 395, 65, 57, 263, 202, 220, 226, 235,
        253, 245, 329, 447, 444, 440, 370, 429, 62, 160, 159, 356, 334, 344,
        349, 305, 355, 357, 251, 325, 136, 82, 64, 338, 427, 402, 239, 394, 365,
        209, 122, 425, 145, 133, 271, 301, 268, 312, 383, 223, 228, 234, 363,
        403, 299, 437, 451, 187, 153, 154, 446, 125, 250, 101, 140, 134,
      ],
      rules: {
        account_record: [{ validator: checkAge, trigger: "change" }],
        support_percent: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        support_account: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        self_percent: [{ required: true, message: "请输入", trigger: "blur" }],
        self_account: [{ required: true, message: "请输入", trigger: "blur" }],
        funding_budget: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        project_introduce: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        organ_introduce: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        implement_contact_phone: [
          { required: true, validator: checkPhone, trigger: "change" },
        ],
        implement_contact_job: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        implement_contact_name: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        implement_charge_phone: [
          { required: true, validator: checkPhone, trigger: "change" },
        ],
        implement_charge_job: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        implement_charge_name: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        implement_email: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        implement_mail_address: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        implement_organ_name: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        contact_phone: [
          { required: true, message: "请输入", trigger: "change" },
          rules.phone,
        ],
        contact_job: [{ required: true, message: "请输入", trigger: "blur" }],
        contact_name: [{ required: true, message: "请输入", trigger: "blur" }],
        charge_phone: [
          { required: true, message: "请输入", trigger: "change" },
          rules.phone,
        ],
        charge_job: [{ required: true, message: "请输入", trigger: "blur" }],
        charge_name: [{ required: true, message: "请输入", trigger: "blur" }],
        corporate_code: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        legal_person: [{ required: true, message: "请输入", trigger: "blur" }],
        land_area: [{ required: true, message: "请输入", trigger: "blur" }],
        email: [
          { required: true, message: "请输入", trigger: ["change", "blur"] },
          rules.email,
        ],
        mail_address: [{ required: true, message: "请输入", trigger: "blur" }],
        project_name: [{ required: true, message: "请输入", trigger: "blur" }],
        project_class: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        project_direction: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        organ_class: [{ required: true, message: "请选择", trigger: "change" }],
        province_id: [{ required: true, message: "请选择", trigger: "change" }],
        city_id: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  components: {
    headerPage,
    footerPage,
    AddCommon,
    UploadFile,
    attachment,
    ApplyLevel2Dialog,
    ApplyLevel1Dialog,
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
    user() {
      return this.$store.state.shzzuser;
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null; // 清除引用，帮助垃圾回收
    }
    if (!this.id) {
      this.local();
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.init();
    this.isEnd();
    if (this.id) {
      this.detailInfo(this.id);
    } else {
      if (localStorage.getItem("formStr")) {
        this.ruleForm = JSON.parse(localStorage.getItem("formStr"));
        if (this.ruleForm.province_id) {
          this.cityList();
        }
        if (this.ruleForm.project_class) {
          this.child();
        }
      }
      this.timer = setInterval(() => {
        this.local();
      }, 3000);
    }
  },
  filters: {
    formatDate(val) {
      return zhDate(val * 1000, 1);
    },
  },
  methods: {
    showItem(row, type = 1) {
      this.scoreInfo = row;
      if (type == 1) {
        this.applyLevel1Dialog = true;
      } else {
        this.applyLevel2Dialog = true;
      }
    },
    dialogWatchState() {
      this.applyLevel1Dialog = false;

      this.applyLevel2Dialog = false;
    },
    async isEnd() {
      let _data = await isEnd();
      if (_data.code === 200) {
        this.end = _data.data;
      }
    },
    // 表单提交
    login(formName, type) {
      if (!this.ruleForm.is_agree) {
        return this.$message.error(
          "请同意确认项目申报内容的真实性，并愿意承担相应的责任"
        );
      }
      if (
        this.ruleForm.pdf_file.length === 0
        // ||
        // this.ruleForm.reload_pdf_file.length === 0
      ) {
        return this.$message.error("请上传PDF盖章版实施方案");
      }
      if (
        this.ruleForm.word_file.length === 0
        // ||
        // this.ruleForm.reload_word_file.length === 0
      ) {
        return this.$message.error("请上传word版实施方案");
      }
      // if (type == 1) {
      this.subForm(type);
      //   return;
      // }
      // this.$refs[formName].validate((valid, validates) => {
      //   if (valid) {
      //     this.subForm(type);
      //   } else {
      //     scrollIntoView(this, validates, false);
      //   }
      // });
    },

    local() {
      console.log(1);
      localStorage.setItem("formStr", JSON.stringify(this.ruleForm));
    },

    async subForm(type) {
      let _data;

      _data = await saveProjectFileInfo({
        project_id: this.id ? this.id : "",
        pdf_file: this.ruleForm.pdf_file,
        word_file: this.ruleForm.word_file,
        reload_pdf_file: this.ruleForm.reload_pdf_file,
        reload_word_file: this.ruleForm.reload_word_file,
        is_reload: this.idList.includes(Number(this.id)) ? 1 : 0,
      });

      if (_data.code == 200) {
        this.$message.success(_data.message);
      } else {
        this.$message.error(_data.message);
      }

      return false;
      _data = await saveProjectApplication(
        this.id ? this.id : "",
        this.ruleForm.project_name,
        this.ruleForm.project_class,
        this.ruleForm.project_direction,
        this.ruleForm.organ_class,
        this.ruleForm.province_id,
        this.ruleForm.city_id,
        this.ruleForm.land_area,
        this.ruleForm.mail_address,
        this.ruleForm.post_code,
        this.ruleForm.email,
        this.ruleForm.fax_phone,
        this.ruleForm.legal_person,
        this.ruleForm.corporate_code,
        this.ruleForm.charge_name,
        this.ruleForm.charge_job,
        this.ruleForm.charge_tel,
        this.ruleForm.charge_phone,
        this.ruleForm.contact_name,
        this.ruleForm.contact_job,
        this.ruleForm.contact_tel,
        this.ruleForm.contact_phone,
        this.ruleForm.implement_organ_name,
        this.ruleForm.implement_mail_address,
        this.ruleForm.implement_post_code,
        this.ruleForm.implement_email,
        this.ruleForm.implement_fax_phone,
        this.ruleForm.implement_charge_name,
        this.ruleForm.implement_charge_job,
        this.ruleForm.implement_charge_tel,
        this.ruleForm.implement_charge_phone,
        this.ruleForm.implement_contact_name,
        this.ruleForm.implement_contact_job,
        this.ruleForm.implement_contact_tel,
        this.ruleForm.implement_contact_phone,
        this.ruleForm.organ_introduce,
        this.ruleForm.project_introduce,
        JSON.stringify(this.ruleForm.project_assessment),
        this.ruleForm.funding_budget,
        this.ruleForm.self_account,
        this.ruleForm.self_percent,
        this.ruleForm.support_account,
        this.ruleForm.support_percent,
        JSON.stringify(this.ruleForm.account_record),
        this.ruleForm.total_account,
        JSON.stringify(this.ruleForm.other_file),
        1
      );
      if (_data.code == 200) {
        this.$message.success(_data.message);
        if (type == 1) {
          this.id = _data.data.id;
          clearInterval(this.timer);
          localStorage.removeItem("formStr");
          this.$router.push({
            path: "/project_formsub",
            query: {
              id: _data.data.id,
            },
          });

          this.detailInfo(_data.data.id);
        } else {
          this.to(`/orghome/index`);
        }
      } else {
        this.$message.error(_data.message);
      }
    },

    async detailInfo(id) {
      let _data = await getProjectApplicationDetail(id);
      if (_data.code == 200) {
        this.ruleForm = _data.data;
        this.ruleForm.other_file = JSON.parse(this.ruleForm.other_file);
        this.ruleForm.pdf_file = this.ruleForm.pdf_file
          ? JSON.parse(this.ruleForm.pdf_file)
          : [];
        this.ruleForm.word_file = this.ruleForm.word_file
          ? JSON.parse(this.ruleForm.word_file)
          : [];
        this.ruleForm.reload_pdf_file = this.ruleForm.reload_pdf_file
          ? JSON.parse(this.ruleForm.reload_pdf_file)
          : [];
        this.ruleForm.reload_word_file = this.ruleForm.reload_word_file
          ? JSON.parse(this.ruleForm.reload_word_file)
          : [];
        // this.ruleForm.checked = _data.data.is_agree
        // Vue.$set(this.ruleForm.is_agree, true);
        // console.log(_data.data.is_agree)
        // console.log(this.ruleForm.checked)
        this.child();
        this.cityList();
      } else {
        this.$message.error(_data.message);
      }
    },

    async init() {
      // 申报单位属性列表
      let res = await getOrganClassList();
      if (res.code == 200) {
        this.orgclass = res.data;
        this.orgclass.map((item) => {
          item.label = item.name;
        });
      }
      // 项目方向列表
      let _data = await getProjectClassList();
      this.directionOne = _data.data;
      this.directionOne.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
      // 城市列表
      let _info = await cityList();
      this.provinceclass = _info.data;
      this.provinceclass.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
    },

    budgetMoney() {
      if (
        this.ruleForm.funding_budget != "" &&
        this.ruleForm.self_account != "" &&
        this.ruleForm.support_account != ""
      ) {
        let num = addAd(
          Number(this.ruleForm.self_account),
          Number(this.ruleForm.support_account)
        );
        if (num != Number(this.ruleForm.funding_budget)) {
          this.$message.info("资金预算请确认");
        }
      }
    },

    budgetMoneyBFB() {
      if (
        this.ruleForm.self_percent != "" &&
        this.ruleForm.support_percent != ""
      ) {
        let num = addAd(
          Number(this.ruleForm.self_percent),
          Number(this.ruleForm.support_percent)
        );
        if (num != 100) {
          this.$message.info("资金比例请确认");
        }
      }
    },

    async exportProjectPdf() {
      let _data = await exportProjectPdf(this.id);
      if (_data.code == 200) {
        //
        window.open(_data.data);

        // let res = await downloadPdf(this.baseURL + _data.data);
        // let url = window.URL.createObjectURL(new Blob([res.data]));
        // let link = document.createElement("a");
        // link.style.display = "none";
        // link.href = url;
        // link.setAttribute("download", "项目申报.pdf");
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      } else {
        this.$message.error(_data.message);
      }
    },

    // 项目方向层级列表
    async child() {
      let _data = await getProjectClassLevelList(this.ruleForm.project_class);
      this.directionTwo = _data.data;
      this.directionTwo.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
    },

    // 城市列表
    async cityList() {
      let _data = await cityList(this.ruleForm.province_id);
      this.cityclass = _data.data;
      this.cityclass.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
    },

    uploadFile(data) {
      if (
        (data.name === "word_file" ||
          data.name === "pdf_file" ||
          data.name === "reload_word_file" ||
          data.name === "reload_pdf_file") &&
        this.ruleForm[data.name].length >= 1
      ) {
        this.$message.error("只能上传一个文件");
        return;
      }
      this.ruleForm[data.name].push({
        name: data.file.name,
        href: data.file.url,
      });
    },

    attachmentFun() {
      this.dialogVisible = false;
    },

    watchState(data) {
      this.addBool = false;
      if (data) {
        if (data.type == "edit") {
          Vue.set(this.ruleForm.account_record, data.idx, data.obj);
        } else {
          this.ruleForm.account_record.push(data.obj);
        }
        let num = 0;
        this.ruleForm.account_record.map((item) => {
          num = addAd(num, item.total_price).toFixed(2);
        });
        this.ruleForm.total_account = num;
        if (this.ruleForm.account_record.length == 1) {
          this.$refs.ruleForm.validateField("account_record");
        }
      }
    },

    handleEdit(index, row) {
      this.row = row;
      this.idx = index;
      this.addBool = true;
    },

    handleDelete(index, name) {
      this.ruleForm[name].splice(index, 1);
      if (this.ruleForm.account_record.length == 0) {
        this.ruleForm.total_account = 0;
      } else {
        let num = 0;
        this.ruleForm.account_record.map((item) => {
          num = addAd(num, item.total_price).toFixed(2);
        });
        this.ruleForm.total_account = num;
      }
    },

    // 跳转
    to(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-form-item__label {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
    line-height: 50px;
  }

  .el-input__inner {
    height: 50px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-textarea__inner {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-select {
    width: 100%;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }
}

.box {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/banner_01.png") no-repeat top center;
  background-size: auto 620px;

  .btnbox {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 30px;
    margin-bottom: 50px;
    .tips {
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #999;
      margin-top: 10px;
    }
    .bor {
      width: 170px;
      height: 60px;
      background-color: #ffffff;
      border-radius: 10px;
      border: solid 1px #1546c5;
      text-align: center;
      line-height: 58px;
      font-size: 20px;
      letter-spacing: 2px;
      color: #1546c5;
      cursor: pointer;
      margin: 0 20px;
    }

    .bg {
      width: 170px;
      height: 60px;
      background-color: #ffffff;
      border-radius: 10px;
      text-align: center;
      line-height: 60px;
      font-size: 20px;
      letter-spacing: 2px;
      color: #ffffff;
      cursor: pointer;
      background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
      margin: 0 20px;
    }
  }

  .image-slot {
    width: 350px;
    height: 158px;
    background-color: #ffffff;
    border: dotted 1px #d2d2d2;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;

    i {
      font-size: 60px;
      color: #e0dddd;
    }

    > div {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #1546c5;
    }

    > P {
      width: 100%;
      text-align: center;
      font-size: 14px;
      letter-spacing: 1px;
      color: #d3d3d3;
    }
  }

  .ziplist {
    width: 100%;
    padding-bottom: 30px;

    .zip-item {
      width: 100%;
      height: 49px;
      background-color: #f7f7f7;
      padding: 0 20px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      a {
        flex: 1;
        width: 0;
        font-size: 14px;
        letter-spacing: 1px;
        color: #333333;
        cursor: pointer;
      }

      span {
        font-size: 14px;
        letter-spacing: 1px;
        color: #999;
        cursor: pointer;
      }
    }
  }

  .boxTop {
    width: 100%;

    .shuoming {
      width: 100%;
      padding: 10px;
      background: #e9effa url("../../assets/images/line.png") no-repeat top
        center;
      background-size: auto 10px;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);

      .shuoming-content {
        width: 100%;
        padding: 30px;
        background: #ffffff;

        .shuoming-tex {
          width: 100%;
          font-size: 18px;
          letter-spacing: 1px;
          color: #333333;
          line-height: 32px;
          margin-bottom: 10px;
        }

        .shuoming-title {
          width: 100%;
          font-size: 20px;
          letter-spacing: 1px;
          color: #1546c5;
          font-weight: bold;
          margin-bottom: 20px;
        }
      }
    }

    .head-box {
      width: 100%;
    }

    .banner {
      width: 100%;
      padding: 60px 0;

      .title-btn {
        width: 100%;
        padding-top: 35px;

        button {
          display: block;
          width: 184px;
          height: 52px;
          background-color: #ffffff;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          letter-spacing: 2px;
          color: #1546c5;
          font-weight: bold;

          i {
            font-size: 18px;
            color: #1546c5;
            font-weight: bold;
            margin-left: 10px;
          }
        }
      }

      .title-time {
        width: 100%;
        font-size: 18px;
        letter-spacing: 2px;
        color: #f7e34d;
      }

      .title-img {
        width: 100%;
        padding: 50px 0;

        img {
          width: 674px;
          height: auto;
        }
      }

      .title-h4 {
        width: 100%;
        font-size: 24px;
        letter-spacing: 2px;
        color: #ffffff;
      }
    }

    .boxCenter {
      width: 100%;

      .boxMain {
        width: 100%;
        background: #ffffff;
        padding: 0 30px;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);
        margin-top: 20px;
        padding-bottom: 20px;

        .item-feedback {
          width: 100%;
          padding: 10px 0;
          //background-color: #f7f7f7;
          font-size: 16px;
          font-weight: bold;
          color: #ed3434;
          margin-top: 10px;

          span {
            color: #333333;
            font-weight: normal;
          }
        }

        .addbtn {
          width: 100%;
          display: flex;
          justify-content: center;

          span {
            width: 120px;
            height: 32px;
            background-color: #1546c5;
            border-radius: 0px 0px 10px 10px;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;
          }
        }

        .tabel-box {
          width: 100%;
          padding: 20px 0;
        }

        .num-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 52px;
          background-color: #ecf1ff;
          padding: 0 20px;
          margin: 20px 0;

          b {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            span {
              color: #f56c6c;
              font-weight: normal;
              margin-right: 2px;
            }
          }

          span {
            font-size: 16px;
            color: #1546c5;
          }
        }

        .form-tit {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 30px 0;

          i {
            width: 8px;
            height: 22px;
            background-color: #1546c5;
            margin-right: 5px;
          }

          b {
            font-size: 20px;
            letter-spacing: 2px;
            color: #1546c5;
            font-weight: bold;
            span {
              font-size: 16px;
              color: red;
              margin-left: 0px;
              letter-spacing: 0;
              cursor: pointer;
              text-decoration-line: underline;
            }
          }
        }

        .titles {
          width: 100%;
          font-size: 16px;
          color: #333333;
          margin-bottom: 10px;

          b {
            color: #f56c6c;
            font-weight: normal;
          }
        }
      }
    }
  }
}
</style>
